export function paginate(array, pageSize, pageNumber) {
  return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
  // (pageNumber - 1) dado que el número natural de inicio es 1.
} 